import i18n from "i18next";
import { IBaseError } from "types";

const tryT = (key: string): string | null => {
    const fullKey = `messages.${key}`;
    const translated = i18n.t(fullKey);
    return translated !== fullKey ? translated : null;
};

export const getErrorMessages = (error: IBaseError): string[] => {
    let errorMessages: string[] = [];

    if (error.errors && Object.keys(error.errors).length > 0) {
        Object.entries(error.errors).forEach(([key, values]) => {
            const arr: string[] = Array.isArray(values) ? (values as string[]) : values != null ? [String(values)] : [];

            if (arr.length > 0) {
                arr.forEach(v => {
                    const msg = tryT(v);
                    if (msg) {
                        errorMessages.push(msg);
                    } else {
                        const fieldMsg = tryT(key);
                        if (fieldMsg) {
                            errorMessages.push(fieldMsg);
                        } else {
                            errorMessages.push(i18n.t("messages.unexpected_fail"));
                        }
                    }
                });
            } else {
                const fieldMsg = tryT(key);
                errorMessages.push(fieldMsg ?? i18n.t("messages.unexpected_fail"));
            }
        });
    } else {
        const msg = tryT(error.message);
        errorMessages.push(msg ?? i18n.t("messages.unexpected_fail"));
    }
    if (Array.isArray(errorMessages)) {
        errorMessages = [...new Set(errorMessages)];
    }
    return errorMessages;
};
